module.exports = __webpack_public_path__ + "img/List_Line_16px_Icon_light.bac39a82.svg";